import {
  OrganizationErrors,
  OrganizationErrorExtensions,
} from './organizations';
import { PaidAccountErrors, PaidAccountErrorExtensions } from './paidAccount';

enum UnknownErrorExtensions {
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
}

export const Errors = {
  ...OrganizationErrors,
  ...PaidAccountErrors,
} as const;

export const ErrorExtensions = {
  ...OrganizationErrorExtensions,
  ...PaidAccountErrorExtensions,
  ...UnknownErrorExtensions,
} as const;

export type ErrorType = keyof typeof Errors;
export type ErrorExtensionsType = keyof typeof ErrorExtensions;
export {
  OrganizationErrors,
  OrganizationErrorExtensions,
  PaidAccountErrors,
  PaidAccountErrorExtensions,
};
